import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import CheckBoxField from "../../AddFeeds/Elements/CheckboxField";
import Customization from "../elements/Customization";
import FormSettings from "../elements/FormSettings";

import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";
import { UPDATE_PHOTOBOOTH } from "../../../../../../actions/appsMoreAction";
import { CalendlyPop, parseStringObj } from "../../../../../../utils";
import { HUBSPOT_URL } from "../../../../../../actions/api";
import axios from "axios";

const getDefaultEntry = async () => {
    try {
        const response = await axios.get(`https://app.socialwalls.com/data/photobooth-default-data.json?v=${Date.now()}`);
        return response.data;
    } catch (error) {
        return { backgrounds: [], frames: [], stickers: [] };
    }
}

const ActionSection = ({ selectedBg, selectedFrame, stickers, formState, photoBoothData, handleParentChange, onTextFieldChange, submitSetting }) => {
    const [state, setState] = useState({
        onsiteEnable: photoBoothData?.photo_booth_status,
    
        backgrounds: [],
        selectedBackground: [],

        frames: [],
        selectedFrames: [],

        stickers: [],
        selectedStickers: [],

        showPopUp: false,
    });
    const dispatch = useDispatch();
    const wallId = localStorage.getItem("wallId");
    const handleChange = (key, value) =>  setState(prev => ({ ...prev, [key]: value }));
    const uploadImage = (path, type) => {
        setState(prev => {
            const updatedState = { ...prev };
            if (type === "backgrounds") {
                updatedState.backgrounds = [...prev.backgrounds, path];
                updatedState.selectedBackground = [...prev.selectedBackground, path];
            } else if (type === "frames") {
                updatedState.frames = [...prev.frames, path];
                updatedState.selectedFrames = [...prev.selectedFrames, path];
            } else {
                updatedState.stickers = [...prev.stickers, path];
                updatedState.selectedStickers = [...prev.selectedStickers, path];
            }
            return updatedState;
        });
    }

    const submitFormSetting = () => {
        const { settingAction } = formState;
        if (settingAction == 1) {
            const obj = {  wallId: localStorage.getItem('wallId'), network: 30, filter: 10,
                photo_booth_backgrounds: JSON.stringify(state.selectedBackground || []),
                photo_booth_frames: JSON.stringify(state.selectedFrames || []),
                photo_booth_stickers: JSON.stringify(state.selectedStickers || []),
            }
            handleParentChange("isloading", true);
            dispatch(UPDATE_PHOTOBOOTH(obj, () => handleParentChange("isloading", false)))
        } else {
            submitSetting();
        }
    }

    const updateStatus = (status) => {
        setState(prev => ({ ...prev, onsiteEnable: status }));
        dispatch(UPDATE_PHOTOBOOTH({ wallId: localStorage.getItem('wallId'), network: 30, filter: 10, photo_booth_status: Number(status) }, () => {}))
    }

    const handlePopUp = (status) => {
        setState(prev => ({ ...prev, showPopUp: status }));
    }

    useEffect(() => {
        const setDefaultData = async () => {
            const backgrounds = parseStringObj(photoBoothData?.photo_booth_backgrounds) || [];
            const frames = parseStringObj(photoBoothData?.photo_booth_frames) || [];
            const stickers = parseStringObj(photoBoothData?.photo_booth_stickers) || [];
            const { backgrounds: defaultBackgrounds, frames: defaultFrames, stickers: defaultStickers } = await getDefaultEntry();
            setState(prev => ({ ...prev, backgrounds: [...new Set([...backgrounds, ...defaultBackgrounds])], frames: [...new Set([...frames, ...defaultFrames])], stickers: [...new Set([...stickers, ...defaultStickers])], selectedBackground: backgrounds, selectedFrames: frames, selectedStickers: stickers, onsiteEnable: photoBoothData?.photo_booth_status }));
        }
        setDefaultData();
    }, [photoBoothData]);

    return (
        <div className="photo-booth-action w-100 bg-white p-4 pe-2 rounded-8 shadow h-100" id="photobooth-settings">
            {!formState.settingAction
                ? <>
                    <div className="d-flex align-items-center justify-content-between mb-4 pe-2">
                        <h5 className="m-0 d-flex align-items-center">
                            <Link to={`/wall/index/${wallId}`}>
                                <i className="fa fa-angle-left" aria-hidden="true"></i>
                            </Link>
                            <span className="ms-3">PhotoBooth</span>
                        </h5>
                        <span className="switch">
                            <label className="checkbox checkbox-outline checkbox-outline-2x checkbox-primary">
                                <CheckBoxField isChecked={state.onsiteEnable} onChangeHandler={(e) => updateStatus(e.target.checked)} text={0} />
                            </label>
                        </span>
                    </div>

                    <div className="pb-scroll pe-3">
                        <div className="ra-tab form-group mb-3">
                            <label className="font-weight-bolder mb-3">Main Settings</label>
                            <div className="settings-list">
                                {[["Photo Customization", 1], ["Form Settings", 2]].map(
                                    ([label, val]) => (
                                        <Button
                                            key={val}
                                            variant="default"
                                            className="d-flex align-items-center justify-content-between py-3 w-100 mb-3 btn-secondary-personalize text-dark"
                                            onClick={() => handleParentChange("settingAction", val)}>
                                            <span className="ms-0 fs-9 fw-medium text-dark">{label}</span>
                                            <FontAwesomeIcon type="regular" icon="angle-right" />
                                        </Button>)
                                )}
                            </div>
                        </div>
                    </div>

                </>
                : formState.settingAction === 1 ? <Customization {...state} appliedBackground={selectedBg} appliedFrame={selectedFrame} appliedStickers={stickers} handleChange={handleParentChange} selectChange={handleChange} uploadImage={uploadImage} handlePopUp={handlePopUp} /> : <FormSettings {...formState} onTextFieldChange={onTextFieldChange} handleChange={(key, value) => handleParentChange(key, value)} uploadImage={(logo) => handleParentChange("logoImg", logo)} handlePopUp={handlePopUp}/>
            }

            {formState.settingAction ? <div className="form-actions pt-3">
                <div className="card-toolbar f-center">
                    <Button variant="secondary" type="button" className="me-2 w-50" onClick={() => handleParentChange("settingAction", null)}>Back</Button>

                    <Button disabled={formState.isloading} className={`commanBtn btn-md btn btn-dark me-2 w-50 ${formState.isloading ? `spinner spinner-white spinner-right disabled` : null}`} variant="dark" onClick={submitFormSetting}>Save</Button>

                    <OverlayTrigger placement="top" overlay={<Tooltip>Help</Tooltip>}>
                        <a className="lity_lightbox"
                            href="https://vimeo.com/545382711/aa0432f118"
                            data-support="https://taggbox.com/support/how-to-change-background-for-your-social-media-widget/"
                            data-lity>
                            <FontAwesomeIcon type="regular" icon="circle-question" />
                        </a>
                    </OverlayTrigger>
                </div>
            </div> : null}
            <CalendlyPop show={state.showPopUp} hidePop={()=>handlePopUp(false)} url={HUBSPOT_URL}/>
        </div>
    );
}

export default React.memo(ActionSection);